module.exports = __webpack_public_path__ + "static/media/rcs-beraucoal-nav.9beda1e0.png";